enum SDS_INFO_MSG {
  INFO = 'info',
  WARNING = 'warning',
  DANGER = 'danger',
}

export default SDS_INFO_MSG;
